import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'searchName',
  pure: false,
})
@Injectable()
export class SearchName implements PipeTransform {
  transform(items: any[], args: any): any[] {
    if (items == null)
      //since the async may still be working
      return [];

    var isSearch = (data: any): boolean => {
      var isAll = false;
      if (typeof data === 'object') {
        isAll = isSearch(data.name);
      } else {
        isAll = data.toString().match(new RegExp(args, 'i'));
      }

      return isAll;
    };

    return items.filter(isSearch);
  }
}
